import i18next from 'i18next';
import React from 'react';
import en from './container/i18n/en';
import ptBr from './container/i18n/pt-br';

i18next.addResourceBundle('pt-br', 'fornecedor/container', ptBr);
i18next.addResourceBundle('en', '/fornecedor/container', en);

const FornecedorConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/suprimentos/fornecedor',
      component: React.lazy(() => import('./Fornecedor')),
    },
  ],
};

export default FornecedorConfig;
